import React from 'react'
import { Link } from 'react-router-dom'
import DrawOutline from '@/components/ui/draw-outline'
import './Chip.scss'

const Chip = ({ active = false, text, value, size = 'md', onClick = () => {}, className, to }) => {
  const builtClassName = [
    'chip',
    size === 'sm' && 'chip--sm',
    active && 'chip--active',
  ]
    .filter(Boolean)
    .join(' ')

  const _className = className || builtClassName

  const handleClick = () => value && onClick(value)
  const handleKeyDown = event => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    handleClick()
  }

  const content = (
    <>
      {/* Hover-only "drawn" outline. Skipped when active: the active state
          already has its own always-on gradient border. */}
      {!active && <DrawOutline className="chip__draw" rectClassName="chip__draw-rect" />}
      <span className="chip__label">{text}</span>
    </>
  )

  if (to) {
    return (
      <Link
        to={to}
        className={_className}
        data-key={value}
        onClick={event => {
          // A chip link often sits on a clickable surface (a market card), where the
          // card's own navigation would otherwise win the click.
          event.stopPropagation()
          handleClick()
        }}>
        {content}
      </Link>
    )
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-pressed={active}
      className={_className}
      data-key={value}>
      {content}
    </div>
  )
}

export default Chip
